export default {
  navbar: {
    home: "Accueil",
    features: "Fonctionnalités",
    whyUs: "Pourquoi Nous",
    contactUs: "Nous Contacter",
    faq: "FAQ"
  },
  home: {
    transformingData: "Transformer la Gestion",
    Management: "des données",
    decision: "Prise",
    making: "de Décision",
    with: "avec",
    cutting: "une Technologie de",
    edge: "Pointe",
    technology: "",
    para_01: "Donner aux organisations les moyens d'utiliser des solutions de données évolutives pour des informations exploitables.",
    para_02: "i2Pulse est une plateforme robuste et intuitive conçue pour simplifier la collecte, la gestion et l'analyse des données. Grâce à une automatisation avancée, elle transforme les données brutes en informations exploitables pour les secteurs de la santé, de l'éducation, des gouvernements et des ONG.",
    heading_01: "Caractéristiques Principales et Avantages d'i2Pulse",
    card_heading_01: "Capacités Avancées de Gestion des Données",
    card_heading_02: "Expérience Utilisateur de Haut Niveau",
    card_heading_03: "Analyses et Rapports en Temps Réel",
    card_heading_04: "Écosystème d'Intégration Transparent",
    card_heading_05: "Sécurité et Conformité",
    card_heading_06: "Évolutivité et Personnalisation",
    card_para_01: "Gestion fiable et évolutive des données avec création de formulaires dynamiques, agrégation et désagrégation pour des informations précises.",
    card_para_02: "Une interface intuitive, des flux de travail automatisés et un accès basé sur les rôles améliorent la productivité et la sécurité.",
    card_para_03: "Tableaux de bord interactifs, analyses prédictives et rapports personnalisables pour des décisions basées sur les données en temps réel.",
    card_para_04: "S'intègre sans effort avec des outils tiers, prenant en charge le web, le mobile et les connexions API personnalisées.",
    card_para_05: "Un cryptage avancé, des audits de sécurité et le respect des normes mondiales de conformité garantissent la protection des données.",
    card_para_06: "Une architecture évolutive et des modules personnalisables s'adaptent à la croissance organisationnelle et aux divers flux de travail.",
    heading_02: "Comment Ça Marche",
    para_03: "i2Pulse rationalise l'ensemble du cycle de vie de la gestion des données, de la collecte à l'analyse et l'automatisation, garantissant une intégration transparente et des données de qualité.",
    dataCollection: "Collecte de Données",
    dataManagement: "Gestion des Données",
    analysisAndReporting: "Analyse et Rapports",
    automation: "Automatisation",
    heading_03: "Prêt à démarrer avec nous ?",
    heading_04: "Transformer la Gestion des Données à Travers les Industries",
    card_heading_07: "Secteur de la Santé",
    card_heading_08: "Éducation",
    card_heading_09: "Agences Gouvernementales",
    card_heading_10: "Organisations à But Non Lucratif (ONG)",
    card_para_07: "Centralise les données des patients, suit les épidémies et surveille les résultats de santé grâce à des modèles prédictifs.",
    card_para_08: "Gère les données des étudiants, suit les performances et automatise les rapports pour la conformité et l'accréditation.",
    card_para_09: "Simplifie les opérations de recensement, améliore la transparence et permet l'intégration de données inter-agences.",
    card_para_10: "Optimise l'allocation des ressources, suit l'impact des programmes et permet la collecte de données mobiles.",
    card_07: {
      list_01: { title: "Dossiers Patients Centralisés", description: "Rationalisez la gestion des données des patients pour un accès rapide et une meilleure prise de décision." },
      list_02: { title: "Surveillance des Épidémies", description: "Surveillez et analysez les épidémies à l'aide de données en temps réel et de la cartographie géospatiale." },
      list_03: { title: "Surveillance des Résultats de Santé", description: "Utilisez des modèles prédictifs pour évaluer et améliorer efficacement les résultats de santé." }
    },
    card_08: {
      list_01: { title: "Gestion des Données Étudiants et Enseignants", description: "Gérez et suivez efficacement les progrès des étudiants et les performances des enseignants." },
      list_02: { title: "Suivi des Performances", description: "Identifiez les tendances et les domaines à améliorer grâce à des informations basées sur les données." },
      list_03: { title: "Rapports Automatisés", description: "Rationalisez l'accréditation et la conformité réglementaire grâce à des rapports automatisés et personnalisables." }
    },
    card_09: {
      list_01: { title: "Opérations de Recensement Simplifiées", description: "Facilitez la collecte et l'analyse de données à grande échelle pour des rapports de recensement précis." },
      list_02: { title: "Surveillance des Programmes de Service Public", description: "Suivez et optimisez les initiatives de service public pour de meilleurs résultats." },
      list_03: { title: "Intégration de Données Inter-agences", description: "Permettez une intégration et une collaboration transparentes des données entre plusieurs agences gouvernementales." }
    },
    card_10: {
      list_01: { title: "Optimisation de l'Allocation des Ressources", description: "Allouez les ressources efficacement en fonction de données et d'informations en temps réel." },
      list_02: { title: "Suivi de l'Impact des Programmes", description: "Surveillez et mesurez le succès des programmes et initiatives pour garantir la responsabilité." },
      list_03: { title: "Collecte de Données Mobiles", description: "Utilisez des outils adaptés aux mobiles pour la collecte de données dans des zones isolées." }
    }
  },
  features: {
    heading_01: "Caractéristiques Principales et Avantages d'i2Pulse",
    banner_title_01: "Gestion Avancée des Données",
    banner_title_02: "Expérience Utilisateur de Haut Niveau",
    banner_title_03: "Analyses et Rapports en Temps Réel",
    banner_title_04: "Écosystème d'Intégration Transparent",
    banner_title_05: "Sécurité et Conformité",
    banner_title_06: "Évolutivité et Personnalisation",
    banner_01: {
      list_01: "Construit sur les technologies éprouvées les plus récentes pour une fiabilité et une évolutivité optimales.",
      list_02: "Prend en charge l'agrégation et la désagrégation des données à plusieurs niveaux.",
      list_03: "Création dynamique de formulaires pour une collecte de données personnalisée et efficace."
    },
    banner_02: {
      list_01: "Interface Utilisateur Intuitive : Conçue pour une utilisation facile, garantissant une navigation sans effort.",
      list_02: "Automatisation : Rationalise les tâches répétitives telles que les importations de données et les validations.",
      list_03: "Contrôle d'Accès Basé sur les Rôles : Personnalise les expériences utilisateurs en fonction des rôles."
    },
    banner_03: {
      list_01: "Tableaux de Bord Interactifs : Visualisez les données avec des graphiques en temps réel et des cartes thermiques.",
      list_02: "Analyses Prédictives : Exploitez des modèles d'apprentissage automatique pour prévoir les tendances.",
      list_03: "Rapports Personnalisables : Générez des rapports automatisés adaptés à vos besoins."
    },
    banner_04: {
      list_01: "S'intègre parfaitement aux outils tiers, notamment les systèmes SIG, les appareils IoT et les CRM.",
      list_02: "Compatible avec les plateformes web et mobiles pour un accès continu aux données.",
      list_03: "Comprend des points de terminaison API pour des intégrations personnalisées."
    },
    banner_05: {
      list_01: "Met en œuvre un cryptage avancé pour un stockage et un transfert sécurisés des données.",
      list_02: "Audits de sécurité réguliers et conformité totale avec les normes mondiales (ex: RGPD).",
      list_03: "Pistes d'audit et journaux d'activité pour garantir la transparence et l'intégrité des données."
    },
    banner_06: {
      list_01: "Conçu pour évoluer avec la croissance de votre organisation, des petites équipes aux grandes entreprises.",
      list_02: "Modules entièrement personnalisables pour s'adapter à des flux de travail uniques.",
      list_03: "Architecture évolutive qui prend en charge des milliers d'utilisateurs simultanés sans compromettre les performances."
    }
  },
  whyUs: {
    heading_01: "Pourquoi i2Pulse ?",
    heading_02: "Pourquoi",
    heading_03: "i2Pulse ?",
    subHeading_01: "Les Atouts Uniques Qui Mènent au Succès",
    card_heading_01: "Solution de Bout en Bout",
    card_heading_02: "Simplicité de l'Innovation",
    card_heading_03: "Accessibilité Mondiale",
    card_heading_04: "Évolutivité Sans Faille",
    card_heading_05: "Sécurité des Données",
    card_heading_06: "Adapté à Vos Besoins",
    card_para_01: "i2Pulse est une plateforme tout-en-un qui simplifie la gestion des données. Elle rationalise les flux de travail, augmente l'efficacité et remplace le besoin de multiples outils.",
    card_para_02: "i2Pulse allie une automatisation puissante à un design intuitif pour simplifier les tâches complexes, améliorant ainsi la productivité.",
    card_para_03: "i2Pulse offre un accès fiable aux données à tout moment, n'importe où. Avec une prise en charge multilingue et des fonctionnalités hors ligne.",
    card_para_04: "À mesure que votre entreprise évolue, i2pulse évolue aussi, garantissant des opérations fluides et efficaces à n'importe quelle échelle.",
    card_para_05: "Vos données sont entre de bonnes mains. Nous priorisons une sécurité de haut niveau, avec un cryptage de pointe et des protocoles de conformité robustes.",
    card_para_06: "i2pulse n'est pas une solution universelle—elle est conçue pour être personnalisée en fonction de votre entreprise unique."
  },
  contactUs: {
    heading_01: "Envoyer un e-mail à",
    heading_02: "Laissez-nous un message",
    or: "Ou",
    name: "Nom",
    email: "E-mail",
    contactNumber: "Numéro de téléphone",
    message: "Message",
    cancel: "Annuler",
    submit: "Soumettre"
  },
  readMore: {
    heading_01: "Comment ça marche",
    subHeading_01: "Rationaliser la gestion des données, de la collecte à la prise de décision",
    banner_title_01: "Collecte de Données",
    banner_title_02: "Gestion des Données",
    banner_title_03: "Analyse et Rapports",
    banner_title_04: "Automatisation",
    banner_01: {
      list_01: "Formulaires Personnalisables : Concevez des formulaires spécifiques à vos besoins.",
      list_02: "Importations Automatisées : Importez des données automatiquement depuis des sources externes.",
      list_03: "Capture de Données en Temps Réel : Collectez des données en temps réel pour une utilisation immédiate.",
      list_04: "Intégration IoT & Bases de Données : Intégration facile avec les appareils IoT.",
      list_05: "Saisie Manuelle : Prise en charge de la saisie manuelle pour les zones sans automatisation."
    },
    banner_02: {
      list_01: "Stockage Avancé : Stockez de grands volumes de données de manière sécurisée.",
      list_02: "Traitement Organisé : Utilisez des technologies avancées pour assurer la cohérence des données.",
      list_03: "Validation des Erreurs : Contrôles intégrés pour identifier et corriger les erreurs.",
      list_04: "Détection des Doublons : Prévenez la duplication des données automatiquement."
    },
    banner_03: {
      list_01: "Tableaux de Bord Interactifs : Visualisez les données à l'aide de graphiques en temps réel.",
      list_02: "KPIs : Suivez les indicateurs clés de performance.",
      list_03: "Capture en Temps Réel : Collectez des données instantanément.",
      list_04: "Rapports Personnalisés : Générez des rapports automatisés ou à la demande."
    },
    banner_04: {
      list_01: "Règles de Flux de Travail : Créez des flux automatisés pour les tâches répétitives.",
      list_02: "Alertes Automatisées : Configurez des alertes pour les changements critiques.",
      list_03: "Automatisation des Opérations de Routine : Exécutez les opérations quotidiennes automatiquement.",
      list_04: "Intervention Humaine Réduite : Minimisez les erreurs humaines."
    }
  },
  common: {
    and: "et",
    registerNow: "S'inscrire Maintenant",
    knowMore: "En Savoir Plus",
    learnMore: "Apprendre Encore Plus",
    requestDemo: "Demander une démo",
    "login": "Se connecter"
  },
  coreCapabilities: {
    tagline: "Capacités principales",
    heading: "Configurez i2Pulse pour l'adapter à vos flux de travail",
    dynamicFormsTitle: "Formulaires dynamiques",
    dynamicFormsDesc: "Capturez et validez les données en toute simplicité.",
    liveDashTitle: "Tableaux de bord en temps réel",
    liveDashDesc: "Visualisez vos opérations en temps réel.",
    roleAccessTitle: "Accès basé sur les rôles",
    roleAccessDesc: "Sécurisez votre environnement numérique.",
    workflowTitle: "Automatisation des workflows",
    workflowDesc: "Éliminez les tâches et rapports manuels."
  },
  performanceBanner: {
    title: "Les performances du programme en un coup d'œil",
    subtitle: "Une visibilité opérationnelle en temps réel pour de vrais résultats.",
    stats: {
      completeness: "Complétude des données",
      records: "Enregistrements traités",
      locations: "Sites actifs",
      reports: "Rapports automatisés"
    }
  },
  everyRole: {
    headingPart1: "Conçu pour",
    headingPart2: "chaque rôle",
    subheading: "Connectez l'ensemble de votre workflow, du terrain à la direction :",
    roles: {
      fieldUsers: {
        title: "Utilisateurs terrain",
        desc: "Saisissez facilement les données grâce à des formulaires numériques simples."
      },
      dataManagers: {
        title: "Gestionnaires de données",
        desc: "Validez instantanément les soumissions pour garantir une précision totale."
      },
      analysts: {
        title: "Analystes",
        desc: "Analysez les tendances et découvrez des informations approfondies et exploitables."
      },
      leaders: {
        title: "Dirigeants",
        desc: "Prenez des décisions éclairées grâce à des tableaux de bord de performance en temps réel."
      }
    }
  },
  versatilePlatform: {
    tagline: "Polyvalent dans tous les secteurs",
    headingPart1: "Une plateforme flexible, prête à répondre à",
    headingPart2: "votre mission spécifique :",
    categories: {
      mAndE: "Suivi et évaluation (S&E)",
      publicHealth: "Surveillance de la santé publique",
      education: "Suivi de l'éducation",
      compliance: "Conformité et prestation de services",
      nonprofit: "Mesure de l'impact des organisations à but non lucratif",
      enterprise: "Performance des entreprises"
    }
  },
  howItWorks: {
    badge: "Comment ça fonctionne",
    heading: {
      line1: "Des données plus intelligentes.",
      line2: "Des workflows plus fluides.",
      highlight: "De meilleurs résultats."
    },
    description: "i2Pulse simplifie l'ensemble du cycle de gestion des données, de la collecte à l'analyse et à l'automatisation, en garantissant une intégration fluide, une qualité des données optimale et des informations exploitables à chaque étape.",
    reliability: {
      line1: "Conçu pour la fiabilité.",
      line2: "Pensé pour l'impact.",
      line3: "Des données fluides. Des décisions plus intelligentes."
    },
    features: {
      collection: {
        title: "Collecte des données",
        desc: "Collectez des données précises depuis n'importe quelle source, en ligne ou hors ligne, en temps réel."
      },
      management: {
        title: "Gestion des données",
        desc: "Organisez, validez et sécurisez vos données grâce à de puissants outils de gestion."
      },
      analysis: {
        title: "Analyse et reporting",
        desc: "Transformez vos données en informations utiles grâce à des tableaux de bord interactifs et des rapports personnalisés."
      },
      automation: {
        title: "Automatisation",
        desc: "Automatisez les workflows et les alertes pour gagner du temps, réduire les erreurs et améliorer la productivité."
      }
    },
    cta: "En savoir plus"
  },
  sectorWiseExamples: {
    badge: "EXEMPLES SPÉCIFIQUES À CHAQUE SECTEUR",
    headingPart1: "Ce que vous pouvez créer avec",
    headingPart2: "i2Pulse",
    description: "Découvrez comment i2Pulse peut être configuré pour s'adapter au langage, aux indicateurs et aux workflows uniques de votre domaine.",
    cards: {
      health: {
        title: "Gestion des informations de santé",
        description: "Configurez des formulaires de surveillance des maladies, de suivi de la vaccination et de reporting des établissements de santé.",
        points: [
          "Surveillez les alertes d'épidémie et les lacunes régionales",
          "Suivez la couverture vaccinale en temps réel",
          "Un tableau de bord unifié pour prendre des décisions rapidement"
        ]
      },
      education: {
        title: "Gestion de l'éducation",
        description: "Créez des profils scolaires complets, suivez les inscriptions des élèves et surveillez les présences quotidiennes.",
        points: [
          "Comparez facilement les performances des districts",
          "Identifiez rapidement les risques de décrochage",
          "Optimisez l'allocation des ressources"
        ]
      },
      government: {
        title: "Suivi des performances gouvernementales",
        description: "Suivez les services aux citoyens, les performances municipales et les programmes de protection sociale.",
        points: [
          "Mesurez la prestation des services et la satisfaction",
          "Surveillez la résolution des réclamations",
          "Garantissez la transparence grâce à des tableaux de bord publics"
        ]
      },
      ngo: {
        title: "Impact des programmes des ONG",
        description: "Transformez les activités de terrain en preuves crédibles et démontrez un impact réel.",
        points: [
          "Suivez la portée auprès des bénéficiaires et les résultats",
          "Mesurez les performances des partenaires",
          "Générez des rapports d'impact prêts à être présentés aux bailleurs"
        ]
      },
      enterprise: {
        title: "Opérations d'entreprise",
        description: "Connectez les équipes réparties grâce à des tableaux de bord KPI internes.",
        points: [
          "Surveillez les performances des agences",
          "Suivez la conformité et la qualité",
          "Optimisez l'utilisation des ressources"
        ]
      },
      research: {
        title: "Programmes de recherche et d'enquêtes",
        description: "Simplifiez la collecte de données grâce à des enquêtes personnalisées et des informations en temps réel.",
        points: [
          "Gérez efficacement les équipes de terrain",
          "Validez les données en temps réel",
          "Exportez des jeux de données propres pour l'analyse"
        ]
      }
    },
    impactBanner: {
      badge: "Conçu pour générer de l'impact"
    },
    impactFeatures: {
      domain: {
        title: "Spécifique au domaine",
        description: "Configurez la plateforme selon votre langage et vos workflows"
      },
      flexible: {
        title: "Flexible et évolutif",
        description: "Adaptez-la à mesure que vos programmes et opérations évoluent"
      },
      evidence: {
        title: "Fondé sur les données probantes",
        description: "Prenez de meilleures décisions grâce à des données fiables"
      },
      secure: {
        title: "Sécurisé et conforme",
        description: "Conçu avec une sécurité et une gouvernance de niveau entreprise"
      },
      impact: {
        title: "Conçu pour l'impact",
        description: "Concentrez-vous sur les résultats qui comptent le plus"
      }
    }
  },
  industrySolutions: {
    badge: "SOLUTIONS PAR SECTEUR",
    heading: {
      part1: "Transformer la gestion des données",
      part2: "dans",
      highlight: "tous les secteurs"
    },
    description: "i2Pulse s'adapte aux workflows uniques des secteurs où des données précises, des rapports rapides et des décisions fondées sur des données probantes sont essentiels à la réussite.",
    sectors: {
      healthcare: {
        title: "Santé et santé publique",
        description: "Centralisez les données des établissements, suivez la surveillance des maladies et optimisez l'allocation des ressources pour améliorer les résultats des patients.",
        features: {
          f1: { label: "Suivre les résultats", text: "Surveillez les épidémies, la prestation des services et les indicateurs de santé." },
          f2: { label: "Cartographier les performances", text: "Visualisez les indicateurs par région, district ou établissement individuel." },
          f3: { label: "Orienter la stratégie", text: "Soutenez une planification proactive de la santé publique et la priorisation des ressources." }
        }
      },
      education: {
        title: "Systèmes éducatifs",
        description: "Gérez les données des étudiants, des enseignants et des établissements dans une plateforme centralisée pour améliorer les résultats scolaires.",
        features: {
          f1: { label: "Suivre les indicateurs", text: "Suivez les inscriptions, l'assiduité et les performances d'apprentissage." },
          f2: { label: "Automatiser la conformité", text: "Simplifiez l'accréditation et le reporting institutionnel." },
          f3: { label: "Préparer l'avenir", text: "Soutenez une planification éducative fondée sur les données probantes pour les districts et les universités." }
        }
      },
      government: {
        title: "Agences gouvernementales",
        description: "Améliorez la transparence, la prestation des services et la planification des politiques grâce à une coordination sécurisée des données entre les agences.",
        features: {
          f1: { label: "Simplifier la collecte", text: "Simplifiez les opérations de recensement et la collecte des données administratives." },
          f2: { label: "Briser les silos", text: "Permettez un partage et un reporting fluides des données entre les agences." },
          f3: { label: "Donner les moyens aux dirigeants", text: "Alimentez des tableaux de bord exécutifs pour prendre des décisions politiques en toute confiance." }
        }
      },
      ngo: {
        title: "Organisations à but non lucratif et ONG",
        description: "Simplifiez le suivi et l'évaluation (S&E) pour suivre les bénéficiaires, mesurer l'impact réel et rendre compte aux bailleurs en toute confiance.",
        features: {
          f1: { label: "Donner les moyens au terrain", text: "Collectez des données partout grâce à des formulaires mobiles et utilisables hors ligne." },
          f2: { label: "Mesurer l'impact", text: "Suivez les activités, les réalisations et les résultats à long terme des programmes." },
          f3: { label: "Mobiliser les bailleurs", text: "Générez des rapports transparents et fondés sur des données probantes pour sécuriser les financements." }
        }
      }
    },
    featuresBanner: {
      f1: {
        title: "Une plateforme unifiée",
        description: "Toutes vos données. Toutes vos équipes. Une source de confiance."
      },
      f2: {
        title: "En temps réel. Partout.",
        description: "Des données et des informations en temps réel, où et quand vous en avez besoin."
      },
      f3: {
        title: "Sécurisé par conception",
        description: "Une sécurité de niveau entreprise pour protéger ce qui compte le plus."
      },
      f4: {
        title: "Données. Décisions. Impact.",
        description: "Transformez l'information en action et créez un impact durable."
      }
    }
  },
  governanceAndSecurity: {
    badge: "GOUVERNANCE ET SÉCURITÉ",
    heading: {
      part1: "Conçu pour la confiance, la responsabilité",
      part2: "et",
      highlight: "un accès contrôlé"
    },
    description: "i2Pulse est un environnement opérationnel sécurisé conçu pour protéger les données sensibles, réglementées et critiques pour vos missions, des dossiers des patients aux informations sur les étudiants et les bénéficiaires.",
    features: {
      roles: {
        title: "Autorisations basées sur les rôles",
        description: "Définissez des niveaux d'accès précis pour les administrateurs, les équipes de saisie, les approbateurs et les partenaires externes."
      },
      audit: {
        title: "Pistes d'audit complètes",
        description: "Garantissez une responsabilité totale en suivant chaque soumission, modification, approbation et export de données."
      },
      access: {
        title: "Contrôle d'accès granulaire",
        description: "Limitez strictement la visibilité des données par zone géographique, service, établissement ou projet spécifique."
      },
      compliance: {
        title: "Préparation à la conformité mondiale",
        description: "Sécurisez vos opérations grâce à un chiffrement robuste et à des pratiques de protection des données conformes au RGPD."
      }
    },
    banner: {
      heading: "Une sécurité intégrée à chaque niveau",
      items: {
        encryption: {
          title: "Chiffrement",
          description: "Protection des données par chiffrement de bout en bout."
        },
        backups: {
          title: "Sauvegardes sécurisées",
          description: "Sauvegardes automatisées pour la récupération des données."
        },
        auth: {
          title: "Authentification",
          description: "MFA et protection renforcée par mot de passe."
        },
        monitoring: {
          title: "Surveillance",
          description: "Détection et surveillance des menaces 24 h/24 et 7 j/7."
        },
        retention: {
          title: "Conservation des données",
          description: "Gérez la conservation et la suppression sécurisée des données."
        }
      }
    },
    footerText: "Vos données. Votre confiance. Notre responsabilité."
  },
  integrationArchitecture: {
    badge: "ARCHITECTURE D'INTÉGRATION",
    headingPart1: "Connectez i2Pulse à votre",
    headingPart2: "écosystème numérique existant",
    description: "Une plateforme de données puissante ne devrait pas fonctionner en vase clos. i2Pulse s'intègre parfaitement à votre écosystème de données.",
    diagram: {
      dataSources: "Sources de données",
      integrations: "Intégrations",
      enterpriseSystems: "Systèmes d'entreprise",
      outputs: "Sorties et destinations"
    },
    featureList: {
      openApi: { title: "Connectivité Open API", description: "Permettez une communication sécurisée et en temps réel entre les systèmes grâce à des points de terminaison API robustes." },
      ecosystem: { title: "Compatibilité avec l'écosystème", description: "Connectez facilement les CRM, appareils IoT, applications mobiles et portails de reporting d'entreprise." },
      gis: { title: "Prise en charge des SIG et de la cartographie", description: "Intégrez les Systèmes d'Information Géographique (SIG) pour une surveillance et une planification avancées basées sur la localisation." },
      dataImports: { title: "Imports de données fluides", description: "Importez facilement les données historiques ou périodiques depuis des bases de données existantes et des feuilles de calcul." },
      customConnectors: { title: "Connecteurs personnalisés", description: "Bénéficiez d'un accompagnement d'intégration personnalisé pour connecter des workflows spécifiques, des plateformes financières et des systèmes propriétaires." }
    },
    dataSources: {
      webMobile: "Formulaires\nWeb et mobiles",
      iot: "Appareils IoT",
      fieldApps: "Applications\nterrain",
      spreadsheets: "Feuilles de calcul",
      legacyDb: "Bases de données\nexistantes"
    },
    integrations: {
      restApi: "API RESTful",
      webhooks: "Webhooks",
      sftp: "SFTP / FTP",
      secureConnectors: "Connecteurs sécurisés"
    },
    enterprise: {
      crm: "Systèmes CRM",
      erp: "Systèmes ERP / financiers",
      hr: "Systèmes RH / paie",
      documentManagement: "Gestion documentaire"
    },
    outputs: {
      dashboards: "Tableaux de bord et\nrapports",
      gisMaps: "SIG et cartes",
      emailSms: "Notifications\nEmail et SMS",
      dataWarehouses: "Entrepôts de données",
      thirdParty: "Applications\ntierces"
    },
    highlights: {
      secureByDesign: { title: "Sécurisé par conception", description: "Le chiffrement de bout en bout, l'authentification par jeton et l'accès basé sur les rôles garantissent la protection de vos données." },
      realTimeSync: { title: "Synchronisation en temps réel", description: "Maintenez la cohérence des données entre les systèmes grâce à une synchronisation en temps réel ou planifiée." },
      scalable: { title: "Évolutif et prêt pour l'avenir", description: "Construit sur une architecture cloud native moderne qui évolue avec vos besoins croissants." },
      reliable: { title: "Fiable et résilient", description: "Une haute disponibilité, une gestion des erreurs et des mécanismes de nouvelle tentative garantissent des opérations ininterrompues." },
      developerFriendly: { title: "Conçu pour les développeurs", description: "Une documentation API complète, un environnement sandbox et des SDK pour accélérer les intégrations." }
    }
  }, trustedBySectors: {
    headingPart1: "La confiance des organisations de",
    headingPart2: "tous les secteurs à travers le monde",
    sectors: {
      health: "Santé",
      education: "Éducation",
      government: "Gouvernement",
      ngos: "ONG",
      enterprise: "Entreprises",
      research: "Recherche"
    }
  },
  faq: {
    badge: "QUESTIONS FRÉQUEMMENT POSÉES",
    headingPart1: "Questions courantes",
    headingPart2: "sur",
    headingHighlight: "i2Pulse",
    description: "Des réponses claires pour vous aider à comprendre comment i2Pulse fonctionne et comment il peut générer un impact pour votre organisation.",
    items: {
      q1: {
        question: "i2Pulse peut-il remplacer les rapports basés sur des feuilles de calcul ?",
        answer: "Oui. Nous remplaçons les feuilles de calcul manuelles par des formulaires numériques structurés, des workflows automatisés et des tableaux de bord en temps réel, offrant à votre équipe une source de données unique et fiable."
      },
      q2: {
        question: "La plateforme peut-elle être personnalisée pour notre secteur ?",
        answer: "Absolument. i2Pulse est hautement configurable pour la santé, l'éducation, le gouvernement, les ONG et les opérations d'entreprise, et s'adapte à vos workflows et à votre terminologie spécifiques."
      },
      q3: {
        question: "i2Pulse prend-il en charge différentes autorisations utilisateur ?",
        answer: "Oui. Le contrôle d'accès granulaire basé sur les rôles vous permet de déterminer précisément qui peut consulter, modifier, approuver ou exporter les données selon sa fonction ou sa localisation géographique."
      },
      q4: {
        question: "i2Pulse peut-il fonctionner avec nos systèmes existants ?",
        answer: "Oui. Nos API ouvertes et nos connecteurs personnalisés s'intègrent parfaitement à vos CRM, outils SIG, bases de données existantes et plateformes d'entreprise."
      },
      q5: {
        question: "i2Pulse convient-il aux équipes distantes ou de terrain ?",
        answer: "Oui. La plateforme propose des workflows adaptés aux appareils mobiles et utilisables hors ligne, permettant à vos équipes terrain de collecter des données essentielles partout, même dans les zones à faible connectivité."
      },
      q6: {
        question: "Comment i2Pulse aide-t-il à la prise de décision ?",
        answer: "Nous connectons la collecte sécurisée des données directement aux tableaux de bord en temps réel, aux rapports automatisés et aux alertes. Cela permet à vos dirigeants d'identifier les risques, d'allouer les ressources et d'agir instantanément grâce à des informations fiables."
      }
    },
    support: {
      heading: "Vous avez encore des questions ?",
      description: "Notre équipe est là pour vous aider à découvrir comment i2Pulse peut transformer vos données en un impact concret et exploitable.",
      contactBtn: "Nous contacter",
      demoBtn: "Planifier une démo"
    }
  },
  dataLifecycle: {
    badge: "Comment ça fonctionne",
    headingPart1: "Le cycle complet",
    headingHighlight: "des données",
    description: "Connectez chaque étape du parcours de vos données — du premier point de collecte sur le terrain jusqu'à la décision finale de la direction."
  },
  processSteps: {
    steps: {
      step1: {
        title: "Collecte des données",
        paragraphs: [
          "Créez des formulaires dynamiques basés sur la logique pour le reporting courant, le suivi terrain ou la conformité.",
          "Collectez exactement les données dont vous avez besoin grâce aux champs obligatoires, à la logique conditionnelle et aux pièces jointes."
        ]
      },
      step2: {
        title: "Validation des données",
        paragraphs: [
          "Détectez les erreurs avant qu'elles n'apparaissent dans vos rapports.",
          "Des règles automatisées signalent instantanément les valeurs manquantes, les doublons et les données hors plage afin de garantir une précision totale."
        ]
      },
      step3: {
        title: "Gestion des données",
        paragraphs: [
          "Organisez vos informations en toute sécurité.",
          "Triez les données par programme, localisation ou rôle utilisateur afin d'alimenter à la fois une analyse opérationnelle détaillée et des vues exécutives de haut niveau."
        ]
      },
      step4: {
        title: "Analyse et reporting",
        paragraphs: [
          "Transformez les données brutes en informations visuelles.",
          "Générez des tableaux de bord, des cartes et des scorecards en temps réel, ou planifiez des rapports automatisés adaptés à des parties prenantes spécifiques."
        ]
      },
      step5: {
        title: "Décisions exploitables",
        paragraphs: [
          "Transformez des données fiables en impact concret.",
          "Identifiez les risques, allouez les ressources et répondez aux besoins opérationnels changeants en toute confiance."
        ]
      }
    },
    panels: {
      validation: {
        summaryTitle: "Résumé de la validation",
        valid: "Valide",
        warnings: "Avertissements",
        errors: "Erreurs",
        issuesTitle: "Problèmes détectés",
        issues: {
          item1: "Valeur manquante dans 'Age'",
          item2: "Entrée en double détectée",
          item3: "'Score' est hors plage"
        }
      },
      management: {
        title: "Gestion des données",
        records: "{{count}} enregistrements",
        dropdowns: {
          program: "Programme",
          allPrograms: "Tous les programmes",
          location: "Localisation",
          allLocations: "Toutes les localisations",
          role: "Rôle utilisateur",
          allRoles: "Tous les rôles"
        },
        programs: {
          nutrition: "Programme de nutrition",
          health: "Programme de santé",
          wash: "Programme WASH",
          education: "Programme d'éducation"
        }
      },
      analysis: {
        overviewTitle: "Vue d'ensemble des performances",
        trendTitle: "Évolution dans le temps",
        mapTitle: "Vue cartographique",
        metrics: {
          totalRecords: "Total des enregistrements",
          coverage: "Couverture",
          locations: "Localisations"
        }
      },
      decision: {
        title: "Centre de décision",
        viewBtn: "Voir",
        items: {
          risk: {
            title: "Zones à haut risque",
            sub: "5 localisations"
          },
          resources: {
            title: "Allocation des ressources",
            sub: "Optimisée"
          },
          alerts: {
            title: "Alertes et notifications",
            sub: "3 nouvelles alertes"
          }
        }
      }
    }
  },
  footer: {
    availableOn: "Disponible sur",
    contactEnquiry: "Contact",
    navigate: "Naviguer",
    usefullLinks: "Liens utiles",
    footer_para: "Vous avez des questions ou besoin d'aide ? Contactez-nous pour une démo ou plus d'informations.",
    description: "Une plateforme d'intelligence de données sécurisée, évolutive et configurable pour les organisations nécessitant des données fiables, des informations en temps réel et de meilleures décisions.",
    allRightsReserved: "Tous droits réservés.",
    playStore: "Play Store",
    appStore: "App Store",
    home: "Accueil",
    features: "Fonctionnalités",
    whyUs: "Pourquoi Nous",
    contactUs: "Nous Contacter",
    register: "S'inscrire",
    login: " Connexion",
    platform: "PLATEFORME",
    solutions: "SOLUTIONS",
    getStarted: "COMMENCER",
    letsBuild1: "Construisons",
    letsBuild2: "plus intelligemment ensemble.",
    requestDemoBtn: "Demander une Démo",
    stayConnected: "Restez Connecté",
    links: {
      Overview: "Aperçu",
      Features: "Fonctionnalités",
      Services: "Services",
      Health: "Santé",
      Education: "Éducation",
      Government: "Gouvernement",
      NGOs: "ONG",
      RegisterNow: "S'inscrire Maintenant",
      Login: "Connexion",
      RequestaDemo: "Demander une Démo"
    },
    bottomLinks: {
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      security: "Sécurité des Données",
      compliance: "Conformité"
    }
  },
  privacy: {
    h1: "Politique de Confidentialité"
  }
};